<template>
  <Modal v-model="isDisplayed" :header="false" :footer="false" class="text-center">
    <header>
      <h2>Level Up!</h2>
      <p>
        Congratulations on completing
        <span class="highlight"
          >{{ levelsCompleted }} level{{ levelsCompleted !== 1 ? "s" : "" }}!</span
        >
      </p>
      <p>Keep up the good work</p>
    </header>
    <div class="lottie-container">
      <lottie-player
        ref="lottie"
        style="width: 100%; height: 100%; object-fit: cover; object-position: center"
        src="/Lottie/level-up.json"
        autoplay
      />
    </div>
    <div class="button-container">
      <button
        class="btn btn-primary"
        type="button"
        @click="$emit('close-complete-level-modal')"
        data-test="complete-level-modal-button"
      >
        Continue
      </button>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Modal } from "uiv";
import { Variant } from "../../typings/shared/levels-variant";

const props = defineProps<{ modelValue: boolean; levelsCompleted: number; variant: Variant }>();

const isDisplayed = computed(() => {
  return props.modelValue;
});

const emit = defineEmits(["close-complete-level-modal"]);

const highlightColour = computed(() => {
  if (props.variant === "team") {
    return "#b0bb36";
  }
  if (props.variant === "user") {
    return "#FCAF17";
  }
  return "#000000";
});
</script>

<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables.less";

header {
  p {
    font-size: 24px;
    margin-bottom: 0;
  }
}

.highlight {
  color: v-bind(highlightColour);
  font-weight: bold;
}

figure {
  margin: 0 auto 20px;

  img {
    width: 75%;
    max-width: 300px;
  }
}

.button-container {
  margin: 0 auto 20px;
}

.lottie-container {
  margin: 0 auto 20px;
  width: 100%;
  max-height: 200px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
